export default __webpack_public_path__ + "static/media/85.2abe8027.png";